import http from '../httpService';
import {getLanguage, t} from 'react-switch-lang';

const nameVal = getLanguage() === "eng" ? "nameEn" : "name";
export function getAllCourtCategoryRisks() {
  return http.get(`/court-category-risks?sort=${nameVal}`);
}

export function updateCourtCategoryRisk(payload) {
  return http.put('/court-category-risks', payload);
}

export function createCourtCategoryRisk(payload) {
  return http.post('/court-category-risks', payload);
}

export function deleteCourtCategoryRisk(id) {
  return http.delete(`/court-category-risks/${id}`);
}
